import S from 'constants/string.const';

//  0. GS-3553 GS-3456 network error -> tested manually
//  1. GS-3553  user not found error -> test errors/login_test
//  2. GS-  failed to fetch stock info error
//  3. GS-3984  add user with existing email

const OLD_ERRORS = Object.freeze({
  // NetworkError.  Something unrecoverable has gone wrong with the http connection.
  // Most frequently seen when the wi-fi connection goes down
  NetworkError: `I’m struggling to connect to the internet.
  Please turn me off and on and give it another whirl!`,

  // UserNotFoundException:  Seen in login and/or password reset when the email address doesn't match
  // our records.   Most often seen by users who have mistyped/misremembered their email address.
  UserNotFoundException: `We can’t seem to find you!
  Can you check the spelling of your email…`,

  // Failed to fetch:
  // Seen anywhere where there has been a "mid-request" failure
  // - seen by users who are on intermittent wi-fi, so sometimes works, sometimes doesn't
  'Failed to fetch': `Sorry, your request to the server has failed. 
  Please logout and login again and if you continue to see this message, contact support via the chat bubble.`,

  // Seen in Permissions when trying to add/modify a user
  'Error: User association exists.Try edit!': 'That user already has an account, please choose a different email',

  // fetch timeout after 30s Seen by users who are on a slow wi-fi connection,
  // and/or have done something that takes far too long.
  // E.g. requested a report that contains more data than we can calculate right now.
  // Trying again might work in some cases, and not in others
  'fetch timeout after 30s': 'Ooops, please hit refresh.',

  'user access denied': `Eeek sorry, not allowed…
  This login isn’t able to make changes here, please get in touch with your manager to edit :slightly_smiling_face`,

  'Unknown error with code 500': 'Sorry your last action has failed - please refresh/try again or contact Slick if it keeps happening',

  Unknown: `Sorry, something went wrong. Please logout and login again and if you continue to see this message,
contact support via the chat bubble.`,

  UnknownExtra: `
   ${S.newline} Error details: `,
});

// noinspection JSUnusedGlobalSymbols
export default OLD_ERRORS;
